import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "size", "mode", "isDisabled", "itemInsertLocation", "name", "onInit", "onWarning", "onError", "onInitFile", "onAddFileStart", "onAddFileProgress", "onProcessFileStart", "onProcessFileAbort", "onProcessFile", "onProcessFiles", "onRemoveFile", "onPrepareFile", "onUpdateFiles", "onActivateFile", "onReorderFiles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { StyledDropzoneContainer, StyledDropzone } from './Dropzone.styles';
import { registerPlugin } from 'react-filepond';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { jsx as _jsx } from "react/jsx-runtime";
registerPlugin(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);
var Dropzone = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      size = _ref.size,
      mode = _ref.mode,
      _ref$isDisabled = _ref.isDisabled,
      disabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$itemInsertLocati = _ref.itemInsertLocation,
      itemInsertLocation = _ref$itemInsertLocati === void 0 ? 'after' : _ref$itemInsertLocati,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'dropzone' : _ref$name,
      oninit = _ref.onInit,
      onwarning = _ref.onWarning,
      onerror = _ref.onError,
      oninitfile = _ref.onInitFile,
      onaddfilestart = _ref.onAddFileStart,
      onaddfileprogress = _ref.onAddFileProgress,
      onprocessfilestart = _ref.onProcessFileStart,
      onprorcessfileabort = _ref.onProcessFileAbort,
      onprocessfile = _ref.onProcessFile,
      onprocessfiles = _ref.onProcessFiles,
      onremovefile = _ref.onRemoveFile,
      onpreparefile = _ref.onPrepareFile,
      onupdatefiles = _ref.onUpdateFiles,
      onactivatefile = _ref.onActivateFile,
      onreorderfiles = _ref.onReorderFiles,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-dropzone"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(StyledDropzoneContainer, {
      className: className,
      children: _jsx(StyledDropzone, _objectSpread({
        ref: ref,
        id: id,
        itemInsertLocation: itemInsertLocation,
        disabled: disabled,
        name: name,
        oninit: oninit,
        onwarning: onwarning,
        onerror: onerror,
        oninitfile: oninitfile,
        onaddfilestart: onaddfilestart,
        onaddfileprogress: onaddfileprogress,
        onprocessfilestart: onprocessfilestart,
        onprocessfileabort: onprorcessfileabort,
        onprocessfile: onprocessfile,
        onprocessfiles: onprocessfile,
        onremovefile: onremovefile,
        onpreparefile: onpreparefile,
        onupdatefiles: onupdatefiles,
        onactivatefile: onactivatefile,
        onreorderfiles: onreorderfiles,
        credits: false
      }, rest))
    })
  });
});
Dropzone.displayName = 'Dropzone';
export default Dropzone;